$(->
  # TODO: 8/9/17 brittany - I suspect the below is stale, as bug reports no longer have a status of 'rejected.'

  $(document).on 'change', '#bug_report_status', ->
    if $('#bug_report_status').val() == 'rejected'
      $('.js-reject-reason-field').show()
      $('.js-comment-field').hide()
    else
      $('.js-reject-reason-field').hide()
      $('.js-comment-field').show()
      false

)